package com.eladfinish.bible.contest.utils

import androidx.compose.ui.unit.LayoutDirection

private val rtlLanguages = setOf("ar", "he", "iw", "fa", "ur")

// Follows the language chosen in the app's Settings (Hebrew until one is chosen), not the
// browser's own language.
actual fun getLayoutDirection(): LayoutDirection =
    if (currentAppLanguageCode in rtlLanguages) LayoutDirection.Rtl else LayoutDirection.Ltr
